import React from 'react';

export default class ShortagePercent extends React.Component {
    static getFlooredFixed(x, d = 3) {
        x = x * Math.pow(10, d);

        if (isNaN(x)) {
            return NaN;
        }
        if (x > 0) {
            return Math.floor(x) / Math.pow(10, d);
        }
        return Math.ceil(x) / Math.pow(10, d);
    }

    render() {
        let result = this.props.row.shortagePercent;
        return <span>{!isNaN(result) && this.constructor.getFlooredFixed(result * 100, 3)} %</span>;
    }
}


// WEBPACK FOOTER //
// ./src/components/cargo/tableComponents/ShortagePercent.js